import {
	AfterViewChecked,
	Component,
	OnInit,
	TemplateRef,
	ViewChild
} from '@angular/core';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import {
	FORMATION_DURATION_MAX,
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENTION,
	PARAM_LABEL_INTERVENANT,
	MISSION_TYPE_PRESCRIPTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Specialite } from 'src/app/shared/models/specialite';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { State } from 'src/app/shared/enums/state.enum';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';
import { PreparationTime } from 'src/app/shared/models/quota/preparation-time';
import { Authority } from 'src/app/shared/models/security/authority';
import { Employee } from 'src/app/shared/models/employee/employee';
import { forkJoin } from 'rxjs';
import {
	CompetencesElementaires,
	hasEmployeeSkill
} from 'src/app/shared/enums/competence.enum';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Component({
	selector: 'app-detail-formation',
	templateUrl: './detail-formation.component.html',
	styleUrls: ['./detail-formation.component.scss']
})
export class DetailFormationComponent implements OnInit, AfterViewChecked {
	LABEL_BENEFICIAIRE: string;
	LABEL_INTERVENTION: string;
	LABEL_INTERVENTION_CAPITALIZED: string;
	LABEL_INTERVENANT_CAPITALIZED: string;
	MIN_WORKING_HOUR = this.facade.dataStorageService.getParamMinDay();
	minWorkingHourAsDate = new Date(
		new Date().setHours(this.MIN_WORKING_HOUR, 0, 0, 0)
	);
	MAX_WORKING_HOUR = this.facade.dataStorageService.getParamMaxDay();
	maxWorkingHourAsDate = new Date(
		new Date().setHours(this.MAX_WORKING_HOUR, 0, 0, 0)
	);
	MAX_DURATION = this.numberToHoursNumber(FORMATION_DURATION_MAX);
	MAX_NOTES_LENGTH = 1023;
	etat = State;

	missionRequest: MissionRequest;
	confirmDeleteModalRef: BsModalRef;
	confirmEditionModalRef: BsModalRef;
	copyMissionModalRef: BsModalRef;

	radioModel = 'Middle';

	currentBeneficiaire: Beneficiaire;

	_readyTime = new Date();
	_dueTime = new Date();
	_duration = new Date();

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isSAE = false;

	isAPrescription: boolean;

	isTWActive = false;

	formationDetailForm = new FormGroup(
		{
			beneficiaire: new FormControl(''),
			typeIntervention: new FormControl(''),
			date: new FormControl<Date>(null, Validators.required),
			readyTime: new FormControl<Date>(null, [
				Validators.required,
				workingTimeValidator(this.MIN_WORKING_HOUR, this.MAX_WORKING_HOUR)
			]),
			dueTime: new FormControl<Date>(null, [
				Validators.required,
				workingTimeValidator(this.MIN_WORKING_HOUR, this.MAX_WORKING_HOUR)
			]),
			duration: new FormControl<Date>(null),
			missionPlace: new FormControl(null),
			speciality: new FormControl(null),
			notes: new FormControl('', Validators.maxLength(this.MAX_NOTES_LENGTH)),
			isMissionPlaceBeneficiaireAddress: new FormControl(false),
			isRemote: new FormControl(false),
			reminder: new FormControl(false),
			preparationTimePercentage: new FormControl(25, Validators.required),
			missionType: new FormControl(null, Validators.required),
			nombreIntervenants: new FormControl(1, Validators.required),
			centerDepartment: new FormControl(null)
		},
		{
			validators: [
				durationValidator(this.MAX_DURATION),
				missionPlaceRequiredOnMissionType(this.isSESSAD),
				beneficiaireRequiredOnMissionType
			]
		}
	);

	isFormReadOnly = true;
	isRedirected = false;

	listBeneficiaire: Beneficiaire[];
	listBeneficiaireMapped = []; // list pour le typeahead sous forme {name:nom_beneficiaire,object:beneficiaire}
	listMissionPlace: MissionPlace[];
	listSpecialite: Specialite[];
	listMissionTypes: MissionType[];

	listCompetences;
	selectedCompetences = [];

	user: User;
	isDeletable = false;
	isEditable = true;
	isReunion = false;
	messageInviteIntervenantParticipant = 'Entrez un intervenant à ajouter';

	isEventRecurring = false;
	datesList: Date[] = [];

	selectedMissionPlace: MissionPlace = null;
	selectedTypeIntervention: MissionType = null;
	selectedSpeciality: Specialite = null;
	selectedBeneficiaire: Beneficiaire = null;
	selectedMissionType: MissionType = null;
	selectedCareSkill = null;

	// Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	// la mission est associé au chargeDeMission
	isInProjectManagerArray = false;

	isProjectManager = false;
	isProfessionnelSAE = false;

	modalSuppressionAssignedToPlanningRef?: BsModalRef;

	@ViewChild('modalSuppressionAssignedToPlanning')
	modalSuppressionAssignedToPlanningTemplate: TemplateRef<any>;

	confirmUpdateForGroupTemplateRef?: BsModalRef;

	@ViewChild('confirmUpdateForGroupTemplate')
	confirmUpdateForGroupTemplate: TemplateRef<any>;

	updateGroupChoice = 0;

	preparationTimeList: PreparationTime[] = [];
	selectedPreparationTime: PreparationTime;

	canBeFullyModified: boolean = false;
	missionHasToBeUnassigned: boolean = false;
	// hasMissionAlreadyHappened: boolean = false;

	State = State;

	/* MISSION EN GROUPE */
	maxIntervenantSelectableForMission: number = 2; // nombre maximal d'intervenant pour la mission donnée
	initialNbrOfEmployeeRequiredForThisMission: number = 1; // nombre d'intervenant initial par défaut choisi pour cette mission
	initialNumberOfAssignedIntervenants: number = 0; // nombre d'intervenant qui sont affectés initialement
	numberOfAttendeesSelected: number = 0; // nombre d'intervenant sélectionné dans le listing
	isNumberOfIntervenantSelectedValid: boolean = true; // si le nombre d'intervenant sélectioné en input est trop élevé
	isDisplayableSelectEmployee: boolean = false;

	// si le nombre d'intervenant sélectionné dans la liste est trop élevé par rapport au nombre d'intervenant sélectionné en input
	isDisplayableErrorSelectedEmployeesHigherThanNumberSelected: boolean = false;
	isMissionWithMultipleEmployee: boolean = false;
	Authority = Authority;
	listOfAttendeesOriginal = []; // avant modification par l'utilisateur des participants
	listOfAttendees = [];
	listEmployee = [];
	listEmployeeMapped = [];
	selectedParticipant: string = '';

	/* Copie de mission */
	listOfDates: Date[] = [];
	dateToAdd: Date;

	/* Suppression de mission */
	isConfirmDeleteMissionButtonDisabled: boolean = false;

	/* Employé d'une mission unique si affectée */
	uniqueEmployeeOfMission: Employee;

	centerDepartments: CenterDepartment[];
	selectedCenterDepartment: CenterDepartment = null;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENTION_CAPITALIZED =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENTION
			);
		this.LABEL_INTERVENTION = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.LABEL_BENEFICIAIRE =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.LABEL_INTERVENANT_CAPITALIZED =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.user = this.facade.dataStorageService.getUser();
		this.isProjectManager = this.facade.dataStorageService.isProjectManager();
		this.isProfessionnelSAE =
			this.facade.dataStorageService.isProfessionnelSAE();

		this.isDeletable =
			this.facade.dataStorageService.isPlanificatrice() ||
			this.isProjectManager ||
			this.isProfessionnelSAE;

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();
		this.isSAE = this.facade.dataStorageService.isSAE();
		this.isTWActive = this.isSSIAD || this.isSAAD;

		this.facade.careSkillService
			.getAllCareSkills()
			.subscribe((careskills) => (this.listCompetences = careskills));

		this.getMissionRequestAndInitializeFormData();

		// Routing depuis la modal formation d'un beneficiaire
		this.route.queryParams.subscribe((params) => {
			if (params && params.redirected) {
				this.isFormReadOnly = false;
				this.isRedirected = true;
			}
		});

		this.getCenterDepartments();
	}

	getCenterDepartments() {
		this.facade.centerDepartmentService
			.getAllCenterDepartmentsForUserCenter()
			.subscribe({
				next: (centerDepartments) => {
					this.centerDepartments = centerDepartments;
				},
				error: (err: ErrorResponse) => {}
			});
	}

	typeaheadCenterDepartmentOnSelect(event: TypeaheadMatch): void {
		this.selectedCenterDepartment = event.item as CenterDepartment;
	}

	centerDepartmentsKeyUp(e: any) {
		if (
			this.selectedCenterDepartment &&
			this.selectedCenterDepartment.name +
				' ' +
				this.selectedCenterDepartment.name !=
				e.value
		) {
			this.selectedCenterDepartment = null;
		}
	}

	ngAfterViewChecked() {
		this.adjustTextareaHeight();
	}

	getCareSkillsAsString(): string {
		const careSkills = this.missionRequest.careSkills || [];
		if (careSkills.length > 0) {
			return careSkills.map((skill) => skill.name || 'Sans').join(' | ');
		}
		return 'Sans';
	}

	getMissionRequestAndInitializeFormData() {
		const formationId = +this.route.snapshot.paramMap.get('id');
		console.log('[DEBUG] formationId =', formationId);

		this.facade.formationService.getFormationById(formationId).subscribe({
			next: (missionRequest: MissionRequest) => {
				this.missionRequest = missionRequest;
				console.log(
					'[DEBUG] missionRequest id =',
					this.missionRequest?.parcoursId
				);
				// Traitement spécial si la mission est groupée
				if (this.missionRequest.nombreIntervenant > 1) {
					this.getDataAndSetUpInterfaceForGroupMission();
				} else {
					this.getDataIntervenantForSelectedMission();
				}
				// Update des compétences possibles en fonction du type de centre liée à la mission
				this.updateSelectedCompetencesList();
				// Update des booléens activant/désactivant les boutons d'édition et de suppression
				this.updateIsEditableAndIsDeletable();
				// TODO: harmoniser les prescriptions
				this.isAPrescription =
					this.missionRequest.missionType.type === MISSION_TYPE_PRESCRIPTION;
			},
			complete: () => {
				this.initializeFormData();
			},
			error: (err: ErrorResponse) => {
				this.logger.log(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
			}
		});
	}

	adjustTextareaHeight() {
		const textarea = document.getElementById(
			'inputNotes'
		) as HTMLTextAreaElement;
		if (textarea) {
			textarea.style.height = 'auto';
			textarea.style.height = textarea.scrollHeight + 'px';
		}
	}

	getDataIntervenantForSelectedMission() {
		const isMissionWithOnlyOneEmployee =
			this.missionRequest.nombreIntervenant === 1;
		if (isMissionWithOnlyOneEmployee) {
			this.facade.employeeService
				.getEmployeeByMissionRequestId(this.missionRequest.id)
				.subscribe({
					next: (employee: Employee) => {
						if (employee && employee.firstName && employee.lastName) {
							this.uniqueEmployeeOfMission = employee;
						}
					},
					error: (err) => {
						this.logger.log(err);
					}
				});
		}
	}

	getEmployeeOfMission() {
		const employeeName = this.uniqueEmployeeOfMission
			? this.uniqueEmployeeOfMission.firstName +
			  ' ' +
			  this.uniqueEmployeeOfMission.lastName
			: 'Aucun';
		return employeeName;
	}

	getDepartureAddress(){
		const employeeAdresse = this.missionRequest.departureAddress.label;
		return employeeAdresse;
	}

	updateSelectedCompetencesList() {
		this.missionRequest.careSkills.forEach((c) =>
			this.selectedCompetences.push(c)
		);
	}

	getDataAndSetUpInterfaceForGroupMission() {
		this.isMissionWithMultipleEmployee =
			this.missionRequest.nombreIntervenant > 1;
		this.maxIntervenantSelectableForMission =
			this.missionRequest.missionType.numberOfEmployee;

		// sauvegarde de la valeur initiale du nombre d'intervenant
		this.initialNbrOfEmployeeRequiredForThisMission =
			this.missionRequest.nombreIntervenant;

		// Chercher la liste des participants
		this.facade.meetingService
			.getMultipleEmployeeMissionById(this.missionRequest.id)
			.subscribe({
				next: (meeting: Mission) => {
					this.listOfAttendees = meeting.attendees;
					this.listOfAttendeesOriginal = [...meeting.attendees];
					this.numberOfAttendeesSelected = this.listOfAttendees.length;
					this.initialNumberOfAssignedIntervenants =
						this.listOfAttendees.length;
					this.isDisplayableSelectEmployee =
						this.numberOfAttendeesSelected <
						this.initialNbrOfEmployeeRequiredForThisMission;
				},
				error: (err) => {
					this.logger.log(err);
				}
			});

		// Récupération des employés pour la gestion des participants à une mission groupé
		this.facade.employeeService
			.getAllActiveEmployees()
			.subscribe((allEmployees) => {
				this.listEmployee = allEmployees;

				if (this.isSSIAD) {
					this.listEmployee = this.listEmployee.filter((employee) => {
						return (
							hasEmployeeSkill(employee, CompetencesElementaires.INFIRMIER) ||
							hasEmployeeSkill(employee, CompetencesElementaires.AIDESOIGNANT)
						);
					});
				}

				this.listEmployeeMapped = this.listEmployee.flatMap((e) => {
					return { name: e.firstName + ' ' + e.lastName, object: e };
				});
			});
	}

	isCompetencesElementaires(competence: CareSkill): boolean {
		return !!CompetencesElementaires[competence.name];
	}

	updateIsEditableAndIsDeletable(): void {
		if (this.missionRequest.missionType?.numberOfEmployee === -1) {
			this.isReunion = true;
			this.isEditable = !this.isReunion && !this.isProjectManager;
			this.messageInviteIntervenantParticipant =
				'Entrez un participant à ajouter';
		}

		//Si une mission n'est pas en review (ie. elle est en attente, en cours, terminée ou annulée) elle n'est pas supprimable
		if (State[this.missionRequest.state] !== State.UNDER_REVIEW) {
			this.isDeletable = false;
		}

		if (
			(this.missionRequest.nombreIntervenant === 1 &&
				!this.missionRequest.assignedToPlanning) ||
			this.missionRequest.nombreIntervenant > 1
		) {
			this.isDeletable = true;
		}

		// Si elle est annulée (pour n'importe quelle raison), elle n'est plus éditable
		if (State[this.missionRequest.state].includes(State.CANCELED)) {
			this.isEditable = false;
			this.isDeletable = false;
		}
	}

	initializeFormData(): void {
		if (this.facade.dataStorageService.isProjectManager()) {
			this.facade.missionService
				.getAllMissionsOfProjectManagerByDateformationBetween(
					new Date(this.missionRequest.date),
					new Date(this.missionRequest.date),
					this.user.employee.id,
					this.user.employee.serviceCenter.id
				)
				.subscribe({
					next: (missions: Mission[]) => {
						this.isInProjectManagerArray = missions
							.map((mission) => mission.missionRequest.id)
							.includes(this.missionRequest.id);
						this.isDeletable = this.isDeletable && this.isInProjectManagerArray;
					},
					error: (err) => {
						this.logger.log(err);
					}
				});
		}

		forkJoin({
			beneficiaires: this.facade.beneficiaireService.getBeneficiairesMinimal(),
			missionTypes: this.facade.missionTypeService.getAllMissionTypes(),
			missionPlaces: this.facade.missionPlaceService.getMissionPlacesMinimal(),
			specialties: this.facade.specialiteService.getAllSpecialites(),
			preparationTime: this.facade.centerService.getPreparationTimeForCenter()
		}).subscribe({
			next: (result: {
				beneficiaires: Beneficiaire[];
				missionTypes: MissionType[];
				missionPlaces: MissionPlace[];
				specialties: Specialite[];
				preparationTime: PreparationTime[];
			}) => {
				// Liste des bénéficiaires
				this.listBeneficiaire = result.beneficiaires;
				this.listBeneficiaireMapped = this.listBeneficiaire.flatMap((e) => {
					return {
						name: e.firstName + ' ' + e.lastName,
						object: e
					};
				});
				this.missionRequest.beneficiaire = this.listBeneficiaire.find(
					(b) =>
						b.id === this.missionRequest.beneficiaire?.id &&
						b.firstName === this.missionRequest.beneficiaire?.firstName &&
						b.lastName === this.missionRequest.beneficiaire?.lastName
				);

				// Liste des types de missions
				this.listMissionTypes = result.missionTypes;
				this.formationDetailForm
					.get('missionType')
					.setValue(this.listMissionTypes[0]);

				// Pour savoir laquelle sélectionner dans le form ("disabled" marche pas sur la liste du 'select')
				this.selectedMissionType = this.listMissionTypes.find((missionType) => {
					return missionType.type === this.missionRequest.missionType.type;
				});

				// Liste des lieux d'intervention
				this.listMissionPlace = result.missionPlaces;
				if (!this.missionRequest.missionPlace) {
					this.missionRequest.missionPlace = this.listMissionPlace.find(
						(c) => c.id === this.missionRequest.missionPlace?.id
					);
				}

				this.listSpecialite = result.specialties;
				this.missionRequest.careSpecialty = this.listSpecialite.find(
					(c) => c.id === this.missionRequest.careSpecialty?.id
				);

				// Temps de préparation
				this.preparationTimeList = result.preparationTime;

				this.formationDetailForm
					.get('preparationTimePercentage')
					.setValue(this.missionRequest.preparationTimePercentage);

				// Pour savoir laquelle sélectionner dans le form ("disabled" marche pas sur la liste du 'select')
				this.selectedPreparationTime = this.preparationTimeList.find(
					(preparationTime) => {
						return (
							preparationTime.time ===
							this.missionRequest.preparationTimePercentage
						);
					}
				);
			},
			complete: () => {
				this.setUpAngularForm();
			}
		});
	}

	setUpAngularForm() {
		this._readyTime.setHours(
			this.numberToHoursNumber(this.missionRequest.readyTime)
		);
		this._readyTime.setMinutes(this.missionRequest.readyTime % 60);

		this._dueTime.setHours(
			this.numberToHoursNumber(this.missionRequest.dueTime)
		);
		this._dueTime.setMinutes(this.missionRequest.dueTime % 60);

		this._duration.setHours(
			this.numberToHoursNumber(this.missionRequest.duration)
		);
		this._duration.setMinutes(this.missionRequest.duration % 60);

		this.formationDetailForm.setValue({
			beneficiaire: this.missionRequest.beneficiaire
				? this.missionRequest.beneficiaire?.firstName +
				  ' ' +
				  this.missionRequest.beneficiaire?.lastName
				: '',
			typeIntervention: this.missionRequest.missionType
				? this.missionRequest.missionType.type
				: null,
			date: new Date(this.missionRequest.date),
			readyTime: this._readyTime,
			dueTime: this._dueTime,
			duration: this._duration,
			missionPlace: this.missionRequest.missionPlace
				? this.missionRequest.missionPlace.nameDisplay
				: null,
			speciality: this.missionRequest.careSpecialty
				? this.missionRequest.careSpecialty.name
				: null,
			notes: this.missionRequest.notes,
			isMissionPlaceBeneficiaireAddress:
				!(
					this.missionRequest.missionPlace ||
					(!this.isSESSAD && !this.isSAE) ||
					!this.missionRequest.beneficiaire
				) && !this.missionRequest.remote,
			isRemote: this.missionRequest.remote,
			reminder:
				this.missionRequest.reminderStatus === 'ACTIVE' ||
				this.missionRequest.reminderStatus === 'SENT',

			preparationTimePercentage: this.missionRequest.preparationTimePercentage,

			missionType: this.missionRequest.missionType.type,
			nombreIntervenants: this.missionRequest.nombreIntervenant,
			centerDepartment: this.missionRequest.centerDepartment
				? this.missionRequest.centerDepartment.name
				: null
		});
		if (this.isSSIAD) {
			this.formationDetailForm.removeControl('missionPlace');
		}
		this.selectedMissionPlace = this.missionRequest.missionPlace;
		this.selectedSpeciality = this.missionRequest.careSpecialty;
		this.selectedTypeIntervention = this.missionRequest.missionType;
		this.selectedBeneficiaire = this.missionRequest.beneficiaire;
		this.selectedCenterDepartment = this.missionRequest.centerDepartment;
	}

	typeaheadMissionPlaceOnSelect(event: TypeaheadMatch): void {
		this.selectedMissionPlace = event.item as MissionPlace;
		this.formationDetailForm.patchValue(
			{ isRemote: false, isMissionPlaceBeneficiaireAddress: false },
			{ onlySelf: true }
		);
	}

	missionPlaceKeyUp(e: any) {
		if (
			this.selectedMissionPlace &&
			this.selectedMissionPlace.nameDisplay !== e.value
		) {
			this.selectedMissionPlace = null;
		}
	}

	typeaheadTypeFormationOnSelect(event: TypeaheadMatch): void {
		this.selectedTypeIntervention = event.item as MissionType;
	}

	typeaheadCareSkillOnSelect(event: TypeaheadMatch): void {
		this.selectedCareSkill = event.item;
	}

	typeaheadMissionTypeOnSelect(event: TypeaheadMatch): void {
		this.selectedMissionType = event.item;

		this.maxIntervenantSelectableForMission =
			this.selectedMissionType.numberOfEmployee;
		if (this.isMissionWithMultipleEmployee) {
			this.checkValidityOfNumberOfEmployee();
		}
	}

	typeFormationKeyUp(e: any) {
		if (
			this.selectedTypeIntervention &&
			this.selectedTypeIntervention.type !== e.value
		) {
			this.selectedTypeIntervention = null;
		}
	}

	typeaheadSpecialityOnSelect(event: TypeaheadMatch): void {
		this.selectedSpeciality = event.item as Specialite;
	}

	specialityKeyUp(e: any) {
		if (this.selectedSpeciality && this.selectedSpeciality.name !== e.value) {
			this.selectedSpeciality = null;
		}
	}

	typeaheadBeneficiaireOnSelect(event: TypeaheadMatch): void {
		this.selectedBeneficiaire = event.item.object as Beneficiaire;
		this.formationDetailForm.patchValue(
			{ beneficiaire: event.item.name },
			{ onlySelf: true }
		);
	}

	beneficiaireKeyUp(e: any) {
		if (
			this.selectedBeneficiaire &&
			this.selectedBeneficiaire.firstName +
				' ' +
				this.selectedBeneficiaire.lastName !=
				e.value
		) {
			this.selectedBeneficiaire = null;
		}
	}

	missionTypeKeyUp(e: any) {
		if (
			this.selectedMissionType &&
			this.selectedMissionType.type + ' ' + this.selectedMissionType.type !=
				e.value
		) {
			this.selectedMissionType = null;
		}
	}

	onClickCheckRemote() {
		if (this.isRemote) {
			this.selectedMissionPlace = null;
			this.formationDetailForm.patchValue(
				{ missionPlace: null, isMissionPlaceBeneficiaireAddress: false },
				{ onlySelf: true }
			);
		}
	}

	resetMissionPlace() {
		if (this.isMissionPlaceBeneficiaireAddress) {
			this.selectedMissionPlace = null;
			this.formationDetailForm.patchValue(
				{ missionPlace: null, isRemote: false },
				{ onlySelf: true }
			);
		} else {
			this.selectedMissionPlace = this.missionRequest?.missionPlace;
			this.formationDetailForm.patchValue(
				{ missionPlace: this.missionRequest?.missionPlace?.nameDisplay },
				{ onlySelf: true }
			);
		}
	}

	goBack(): void {
		if (this.isRedirected) {
			this.router.navigate([
				'/gestion/beneficiaires/',
				this.missionRequest.beneficiaire?.id
			]);
		} else {
			this.router.navigate(['/gestion/formations/list']);
		}
	}

	confirmEdition() {
		this.isFormReadOnly = false;
		this.confirmEditionModalRef.hide();
	}

	editForm(): void {
		this.isFormReadOnly = false;
		this.missionHasToBeUnassigned = false;

		if (
			this.missionRequest.assignedToPlanning &&
			this.missionRequest.nombreIntervenant === 1
		) {
			this.canBeFullyModified = false;
		} else {
			this.canBeFullyModified = true;
		}
	}

	stopEditForm(isSubmit: boolean): void {
		const valForm = {};
		this.missionHasToBeUnassigned = false;
		this.formationDetailForm.reset();
		if (isSubmit) {
			this._readyTime = new Date();
			this._readyTime.setHours(
				this.numberToHoursNumber(this.missionRequest.readyTime),
				this.missionRequest.readyTime % 60,
				0,
				0
			);
			this._dueTime = new Date();
			this._dueTime.setHours(
				this.numberToHoursNumber(this.missionRequest.dueTime),
				this.missionRequest.dueTime % 60,
				0,
				0
			);
		} else {
			if (this.isRedirected) {
				this.router.navigate([
					'/gestion/beneficiaires/',
					this.missionRequest.beneficiaire.id
				]);
			}
			this.listOfAttendees = [...this.listOfAttendeesOriginal];
		}

		// Start by extracting the common form field values.
		const commonFormValues = {
			beneficiaire: this.missionRequest.beneficiaire
				? `${this.missionRequest.beneficiaire.firstName} ${this.missionRequest.beneficiaire.lastName}`
				: '',
			typeIntervention: this.missionRequest.missionType
				? this.missionRequest.missionType.type
				: '',
			date: new Date(this.missionRequest.date),
			readyTime: this._readyTime,
			dueTime: this._dueTime,
			duration: this._duration,
			notes: this.missionRequest?.notes,
			speciality: this.missionRequest.careSpecialty
				? this.missionRequest.careSpecialty.name
				: null,
			preparationTimePercentage: this.missionRequest.preparationTimePercentage,
			missionType: this.missionRequest.missionType.type,
			nombreIntervenants: this.missionRequest.nombreIntervenant,
			isRemote: this.missionRequest.remote,
			reminder:
				this.missionRequest.reminderStatus === 'ACTIVE' ||
				this.missionRequest.reminderStatus === 'SENT'
		};

		// Then, handle the conditional logic for the fields that differ.
		if (!this.isSESSAD && !this.isSAE) {
			this.formationDetailForm.setValue({
				...commonFormValues, // Spread the common values.
				isMissionPlaceBeneficiaireAddress: true,
				missionPlace: undefined, // Explicitly setting undefined if needed.
				centerDepartment: null
			});
		} else {
			this.formationDetailForm.setValue({
				...commonFormValues, // Spread the common values.
				missionPlace: this.missionRequest.missionPlace
					? this.missionRequest.missionPlace.nameDisplay
					: null,
				isMissionPlaceBeneficiaireAddress:
					!this.missionRequest?.missionPlace && !this.missionRequest.remote,
				centerDepartment: this.missionRequest.centerDepartment
			});
		}

		this.selectedMissionPlace = this.missionRequest.missionPlace;
		this.selectedSpeciality = this.missionRequest.careSpecialty;
		this.selectedTypeIntervention = this.missionRequest.missionType;
		this.selectedBeneficiaire = this.missionRequest.beneficiaire;
		this.selectedCenterDepartment = this.missionRequest.centerDepartment;
		this.isFormReadOnly = true;
		this.isValidateButtonClicked = false;
	}

	updateMissionRqChoice(choice: number) {
		this.updateGroupChoice = choice;
	}

	/**
	 * mise à jour de la mission_request
	 *
	 * @param choice optionnel : non renseigné = pas de groupe et update normal*
	 * choice = 1 : update only this missionRq
	 * choice = 2 : update this missionRq + all next missionRq of group
	 * choice = 3 : update all missionRq of group
	 */
	updateMissionRq(choice?: number) {
		if (this.formationDetailForm.valid) {
			this.isValidateButtonClicked = true;
			// this.missionRequest.missionType = this.selectedTypeIntervention;
			this.missionRequest.beneficiaire = this.selectedBeneficiaire;

			this.missionRequest.date = new Date(this.formationDetailForm.value.date);
			this.missionRequest.readyTime = this.timeToNumber(
				new Date(this.formationDetailForm.value.readyTime)
			);
			this.missionRequest.dueTime = this.timeToNumber(
				new Date(this.formationDetailForm.value.dueTime)
			);
			this.missionRequest.duration = this.timeToNumber(
				new Date(this.formationDetailForm.value.duration)
			);
			if (
				(this.isSESSAD || this.isSAE) &&
				!this.isMissionPlaceBeneficiaireAddress
			) {
				this.missionRequest.missionPlace = this.selectedMissionPlace;
			} else {
				this.missionRequest.missionPlace = null;
			}
			this.missionRequest.careSkills = [...this.selectedCompetences];

			if (this.selectedSpeciality) {
				this.missionRequest.careSpecialty = this.selectedSpeciality;
			} else {
				//FIXME: Voir avec le back pour ne pas écrire ça en dur
				this.missionRequest.careSpecialty = { id: 0, name: 'Sans' };
			}
			this.missionRequest.notes = this.formationDetailForm.value.notes;
			this.missionRequest.remote = this.formationDetailForm.value.isRemote;
			this.missionRequest.reminderStatus = this.formationDetailForm.value
				.reminder
				? 'ACTIVE'
				: 'INACTIVE';

			if (this.isSESSAD) {
				this.missionRequest.preparationTimePercentage =
					+this.formationDetailForm.value.preparationTimePercentage;

				this.missionRequest.missionType = this.selectedMissionType;
			}

			// Pour update le nombre d'intervenant voulu pour cette mission (sauvegarder dans mission request en BDD)
			this.missionRequest.nombreIntervenant =
				this.formationDetailForm.value.nombreIntervenants;

			// Pour update le nombre d'intervenant sélectionné pour cette mission (peut être inférieur au nombre d'intervenant voulu)
			this.numberOfAttendeesSelected = this.listOfAttendees.length;
			this.missionRequest.centerDepartment = this.selectedCenterDepartment;

			// Premier cas :
			// - pas de groupe de mission (donc update classique)
			// - groupe de mission et option 1 sélectionnée dans la modal "confirmUpdateForGroupTemplateRef" (Update only one missionReq)
			if (!this.missionRequest.isPartOfAGroup || !choice || choice === 1) {
				if (this.missionHasToBeUnassigned) {
					this.facade.formationService
						.desaffecter(this.missionRequest.id)
						.subscribe({
							complete: () => {
								this.missionRequest.assignedToPlanning = false;
								this.classicMissionRequestUpdateEvenIfInGroup();
							},
							error: (err: ErrorResponse) => {
								this.facade.toastService.createHttpErrorToast(
									err.error.response ? err.error.response : '',
									err.status
								);
							}
						});
				} else {
					this.classicMissionRequestUpdateEvenIfInGroup();
				}
			} else if (this.missionRequest.isPartOfAGroup && choice === 2) {
				if (this.missionHasToBeUnassigned) {
					this.facade.formationService
						.desaffecterCurrentAndNext(this.missionRequest.id)
						.subscribe({
							complete: () => {
								this.missionRequest.assignedToPlanning = false;
								this.updateCurrentMissionRequestAndTheNextOnes();
							},
							error: (err: ErrorResponse) => {
								this.facade.toastService.createHttpErrorToast(
									err.error.response ? err.error.response : '',
									err.status
								);
							}
						});
				} else {
					this.updateCurrentMissionRequestAndTheNextOnes();
				}
			} else if (this.missionRequest.isPartOfAGroup && choice === 3) {
				// d'abord on dé-assigne puis on fait l'update
				if (this.missionHasToBeUnassigned) {
					this.facade.formationService
						.desaffecterAll(this.missionRequest.id)
						.subscribe({
							complete: () => {
								this.missionRequest.assignedToPlanning = false;
								this.updateAllMissionRequestFromGroup();
							},
							error: (err: ErrorResponse) => {
								this.facade.toastService.createHttpErrorToast(
									err.error.response ? err.error.response : '',
									err.status
								);
							}
						});
				} else {
					// on update les missions
					this.updateAllMissionRequestFromGroup();
				}
			}
			if (this.missionRequest.isPartOfAGroup) {
				this.confirmUpdateForGroupTemplateRef.hide();
			}
		} else {
			this.isValidateButtonClicked = false;
		}
	}

	updateParticipantsOfMissionAndTheNextOnesIfNecessary() {
		const hasNumberOfIntervenantChanged =
			this.formationDetailForm.value.nombreIntervenants !==
			this.initialNbrOfEmployeeRequiredForThisMission;

		const hasNumberOfSelectedIntervenantChanged =
			this.numberOfAttendeesSelected !==
			this.initialNumberOfAssignedIntervenants;

		if (
			this.isMissionWithMultipleEmployee &&
			(hasNumberOfSelectedIntervenantChanged || hasNumberOfIntervenantChanged)
		) {
			const multipleEmployeeEvent = new Mission();
			multipleEmployeeEvent.missionRequest = this.missionRequest;
			multipleEmployeeEvent.attendees = this.listOfAttendees;
			multipleEmployeeEvent.planner = this.user.employee;

			this.facade.missionService
				.putIntervenantForRecurringMultipleEmployeeEvent(
					this.missionRequest.nombreIntervenant,
					false,
					true,
					multipleEmployeeEvent
				)
				.subscribe({
					complete: () => {
						this.stopEditForm(true);
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.logger.error(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
					}
				});
		} else {
			this.stopEditForm(true);
			this.reload();
		}
	}

	updateParticipantsOfAllMissionOfGroupIfNecessary() {
		const hasNumberOfIntervenantChanged =
			this.formationDetailForm.value.nombreIntervenants !==
			this.initialNbrOfEmployeeRequiredForThisMission;

		const hasNumberOfSelectedIntervenantChanged =
			this.numberOfAttendeesSelected !==
			this.initialNumberOfAssignedIntervenants;

		if (
			this.isMissionWithMultipleEmployee &&
			(hasNumberOfSelectedIntervenantChanged || hasNumberOfIntervenantChanged)
		) {
			const multipleEmployeeEvent = new Mission();
			multipleEmployeeEvent.missionRequest = this.missionRequest;
			multipleEmployeeEvent.attendees = this.listOfAttendees;
			multipleEmployeeEvent.planner = this.user.employee;

			this.facade.missionService
				.putIntervenantForRecurringMultipleEmployeeEvent(
					this.missionRequest.nombreIntervenant,
					true,
					false,
					multipleEmployeeEvent
				)
				.subscribe({
					complete: () => {
						this.stopEditForm(true);
						this.reload();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.logger.error(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
					}
				});
		} else {
			this.stopEditForm(true);
			this.reload();
		}
	}

	updateAllMissionRequestFromGroup() {
		this.facade.formationService.updateAllGroup(this.missionRequest).subscribe({
			next: (succ) => {
				this.logger.log('updateMission success + allGroup: ', succ);
				this.updateParticipantsOfAllMissionOfGroupIfNecessary();
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
			}
		});
	}

	updateCurrentMissionRequestAndTheNextOnes() {
		this.facade.formationService
			.updatePartialGroup(this.missionRequest)
			.subscribe({
				next: (succ) => {
					this.logger.log('updateMission success + partialGroup : ', succ);
					this.updateParticipantsOfMissionAndTheNextOnesIfNecessary();
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked = false;
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
				}
			});
	}

	classicMissionRequestUpdateEvenIfInGroup() {
		// Update nombre d'employé dans la mission request et autres info de bases de la mission request
		this.facade.formationService.update(this.missionRequest).subscribe({
			next: () => {
				// Si la mission est groupé, il peut y avoir des changements dans la liste des participants
				// ou une réduction du nombre de participant prévu
				if (this.missionRequest.nombreIntervenant > 1) {
					this.updateListeParticipants();
				} else {
					this.updateNumberOfIntervenantsIfNecessary();
					this.stopEditForm(true);
					this.reload();
				}
			},
			error: (err: ErrorResponse) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.logger.error(
					'' + err.status + ' ' + err.error.response ? err.error.response : ''
				);
			}
		});
	}

	updateListeParticipants() {
		// si il y a des modifications vis à vis des participants à la mission groupée
		let difference = this.listOfAttendeesOriginal
			.filter((x) => !this.listOfAttendees.includes(x)) // si il y en a plus
			.concat(
				this.listOfAttendees.filter(
					(x) => !this.listOfAttendeesOriginal.includes(x)
				) // et/ou si il y en a en moins
			);

		// si la liste des participants à changer
		if (difference.length > 0) {
			const multipleEmployeeEvent = new Mission();
			multipleEmployeeEvent.missionRequest = this.missionRequest;
			multipleEmployeeEvent.attendees = this.listOfAttendees;
			multipleEmployeeEvent.planner = this.user.employee;

			this.facade.meetingService
				.updateMultipleEmployeeMission(multipleEmployeeEvent)
				.subscribe({
					complete: () => {
						this.logger.log('Update multiple employee mission success');
						// ensuite on va modifier le nombre d'intervenant si nécessaire
						this.updateNumberOfIntervenantsIfNecessary();
					},
					error: (err) => {
						this.logger.error(err);
						this.isValidateButtonClicked = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
					}
				});
		} else {
			// sinon, on va juste modifier le nombre d'intervenant (si nécessaire)
			this.updateNumberOfIntervenantsIfNecessary();
		}
	}

	updateNumberOfIntervenantsIfNecessary() {
		if (
			this.formationDetailForm.value.nombreIntervenants !==
			this.initialNbrOfEmployeeRequiredForThisMission
		) {
			// on met à jour la liste des participants, et le nombre de participants (donc le nombre de mission en BDD créées en avance
			// pour l'affectation des missions multiples)
			this.facade.meetingService
				.updateNumberOfIntervenantOfMissionWithMultipleIntervenants(
					this.missionRequest.id,
					this.formationDetailForm.value.nombreIntervenants
				)
				.subscribe({
					complete: () => {
						this.logger.log(
							'updateNumberOfIntervenantOfMissionWithMultipleIntervenants success'
						);
						this.stopEditForm(true);
						this.reload();
					},
					error: (err) => {
						this.logger.error(err);
						this.isValidateButtonClicked = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
					}
				});
		} else {
			this.stopEditForm(true);
			this.reload();
		}
	}

	shouldDisplayMissionPlace() {
		return (
			(this.isSESSAD || this.isSAE) &&
			!this.isReunion &&
			(!this.isFormReadOnly || this.isMissionPlaceBeneficiaireAddress) &&
			this.selectedBeneficiaire &&
			this.canBeFullyModified
		);
	}

	getAddressLabel() {
		const adressLabel = this.isMissionPlaceBeneficiaireAddress
			? this.missionRequest.beneficiaire.address?.label
			: this.missionRequest.missionPlace?.address?.label;
		// this.logger.info(adressLabel);
		return adressLabel;
	}

	onSubmit() {
		if (this.missionRequest.isPartOfAGroup) {
			this.updateGroupChoice = 0;
			this.confirmUpdateForGroupTemplateRef = this.modalService.show(
				this.confirmUpdateForGroupTemplate,
				{
					class: 'modal-lg'
				}
			);
			this.confirmUpdateForGroupTemplateRef.onHide.subscribe(() => {
				this.confirmUpdateForGroupTemplateRef.hide();
			});
		} else {
			this.updateMissionRq();
		}
	}

	reload() {
		const currentUrl = this.router.url.split('?')[0];
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	timeToNumber(date: Date): number {
		return date.getHours() * 60 + date.getMinutes();
	}

	numberToHoursNumber(temps: number): number {
		return Math.floor(temps / 60) | 0;
	}

	onSwitchRecurrencyChange() {
		this.isEventRecurring = !this.isEventRecurring;
	}

	updateDateList(dates: Date[]) {
		this.datesList = dates;
	}

	/**
	 * suppression de la mission_request
	 *
	 * @param choice optionnel : non renseigné = pas de groupe et suppression normal*
	 * choice = 1 : suppression only this missionRq
	 * choice = 2 : suppression this missionRq + all next missionRq of group
	 * choice = 3 : suppression all missionRq of group
	 */
	deleteMission(choice?: number): void {
		this.isConfirmDeleteMissionButtonDisabled = true;
		if (this.missionRequest.nombreIntervenant > 1) {
			if (!choice || choice === 0 || choice === 1) {
				this.deleteOnlyThisMission();
			} else if (choice === 2) {
				this.deleteThisMissionAndNextOnes();
			} else {
				this.deleteAllMultipleEmployeeMissionOfGroup();
			}
		} else if (!choice || choice === 0 || choice === 1) {
			this.facade.formationService
				.deleteFormation(this.missionRequest)
				.subscribe({
					complete: () => {
						this.confirmDeleteModalRef.hide();
						this.isRedirected = false;
						this.isConfirmDeleteMissionButtonDisabled = false;
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.logger.log(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.isConfirmDeleteMissionButtonDisabled = false;
					}
				});
		} else if (choice === 2) {
			this.facade.formationService
				.deletePartialGroup(this.missionRequest)
				.subscribe({
					complete: () => {
						this.confirmDeleteModalRef.hide();
						this.isConfirmDeleteMissionButtonDisabled = false;
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.logger.log(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.isConfirmDeleteMissionButtonDisabled = false;
					}
				});
		} else if (choice === 3) {
			this.facade.formationService
				.deleteFullGroup(this.missionRequest)
				.subscribe({
					complete: () => {
						this.confirmDeleteModalRef.hide();
						this.isConfirmDeleteMissionButtonDisabled = false;
						this.goBack();
					},
					error: (err: ErrorResponse) => {
						this.logger.log(
							'' + err.status + ' ' + err.error.response
								? err.error.response
								: ''
						);
						this.facade.toastService.createHttpErrorToast(
							err.error.response ? err.error.response : '',
							err.status
						);
						this.isConfirmDeleteMissionButtonDisabled = false;
					}
				});
		} else {
			this.logger.debug("Pas de 'else' définit, comportement par défaut.");
			this.confirmDeleteModalRef.hide();
			this.isRedirected = false;
			this.isConfirmDeleteMissionButtonDisabled = false;
			this.goBack();
		}
	}

	deleteOnlyThisMission() {
		this.facade.meetingService
			.deleteMultipleEmployeeEventById(this.missionRequest.id)
			.subscribe({
				complete: () => {
					this.confirmDeleteModalRef.hide();
					this.isRedirected = false;
					this.isConfirmDeleteMissionButtonDisabled = false;
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
					this.isConfirmDeleteMissionButtonDisabled = false;
				}
			});
	}

	deleteThisMissionAndNextOnes() {
		this.facade.missionService
			.deleteRecurringMultipleEmployeeEvent(
				false,
				true,
				this.missionRequest.date,
				this.missionRequest.id
			)
			.subscribe({
				complete: () => {
					this.confirmDeleteModalRef.hide();
					this.isRedirected = false;
					this.isConfirmDeleteMissionButtonDisabled = false;
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
					this.isConfirmDeleteMissionButtonDisabled = false;
				}
			});
	}

	deleteAllMultipleEmployeeMissionOfGroup() {
		this.facade.missionService
			.deleteRecurringMultipleEmployeeEvent(
				true,
				false,
				null,
				this.missionRequest.id
			)
			.subscribe({
				complete: () => {
					this.confirmDeleteModalRef.hide();
					this.isRedirected = false;
					this.isConfirmDeleteMissionButtonDisabled = false;
					this.goBack();
				},
				error: (err: ErrorResponse) => {
					this.logger.log(
						'' + err.status + ' ' + err.error.response ? err.error.response : ''
					);
					this.facade.toastService.createHttpErrorToast(
						err.error.response ? err.error.response : '',
						err.status
					);
					this.isConfirmDeleteMissionButtonDisabled = false;
				}
			});
	}

	openModalConfirmDelete(confirmDeleteTemplate: TemplateRef<any>): void {
		if (this.missionRequest.isPartOfAGroup) {
			this.updateGroupChoice = 0;
		}
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	validateCancelMission() {
		this.modalSuppressionAssignedToPlanningRef = this.modalService.show(
			this.modalSuppressionAssignedToPlanningTemplate,
			{
				class: 'modal-lg'
			}
		);
	}

	cancelMission(reason: string) {
		this.facade.missionService
			.cancelMissionByMissionIdByMissionRequestId(
				this.missionRequest.id,
				reason
			)
			.subscribe({
				complete: () => {
					this.reload();
					this.modalSuppressionAssignedToPlanningRef.hide();
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	undoCancelMission() {
		this.facade.missionService
			.undoCancelMissionByMissionRequestId(this.missionRequest.id)
			.subscribe({
				complete: () => {
					this.reload();
					this.modalSuppressionAssignedToPlanningRef.hide();
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	isCompetenceCheck(comp: CareSkill): boolean {
		return this.selectedCompetences?.some(
			(currComp) => currComp.id === comp.id
		);
	}

	updateSelectedCompetence(e: any, comp: CareSkill) {
		if (e.target.checked) {
			if (!this.selectedCompetences?.some((z) => z.id === comp.id)) {
				this.selectedCompetences.push(comp);
			}
		} else {
			if (this.selectedCompetences?.some((z) => z.id === comp.id)) {
				this.selectedCompetences = this.selectedCompetences.filter(
					(z) => z.id !== comp.id
				);
			}
		}
	}

	get beneficiaire() {
		return this.formationDetailForm.get('beneficiaire');
	}
	get typeIntervention() {
		return this.formationDetailForm.get('typeIntervention');
	}

	get date() {
		return this.formationDetailForm.get('date');
	}

	get dateAsDate() {
		return new Date(
			this.formationDetailForm.get('date').value.getFullYear(),
			this.formationDetailForm.get('date').value.getMonth(),
			this.formationDetailForm.get('date').value.getDate()
		);
	}
	get dateAsDateMinusOneMonth() {
		return new Date(
			this.formationDetailForm.get('date').value.getFullYear(),
			this.formationDetailForm.get('date').value.getMonth() - 1,
			this.formationDetailForm.get('date').value.getDate()
		);
	}
	get readyTime() {
		return this.formationDetailForm.get('readyTime');
	}
	get readyTimeAsDate() {
		return this.formationDetailForm.get('readyTime').value;
	}
	get dueTime() {
		return this.formationDetailForm.get('dueTime');
	}
	get dueTimeAsDate() {
		return this.formationDetailForm.get('dueTime').value;
	}

	get duration() {
		return this.formationDetailForm.get('duration');
	}

	get durationAsDate() {
		return this.formationDetailForm.get('duration').value;
	}

	get missionPlace() {
		return this.formationDetailForm.get('missionPlace');
	}
	get speciality() {
		return this.formationDetailForm.get('speciality');
	}
	get notes() {
		return this.formationDetailForm.get('notes');
	}

	get isMissionPlaceBeneficiaireAddress() {
		return this.formationDetailForm.get('isMissionPlaceBeneficiaireAddress')
			.value;
	}

	get isRemote() {
		return this.formationDetailForm.get('isRemote').value;
	}

	get reminder() {
		return this.formationDetailForm.get('reminder').value;
	}

	get missionType() {
		return this.formationDetailForm.get('missionType');
	}

	get centerDepartment() {
		return this.formationDetailForm.get('centerDepartment');
	}

	unassignedMission() {
		this.missionHasToBeUnassigned = true;
		this.canBeFullyModified = true;
	}

	typeaheadEmployeeOnSelectForMissionWithMultipleEmployee(
		event: TypeaheadMatch
	): void {
		const empToInsert = event.item.object as Employee;
		if (
			this.listOfAttendees.findIndex((emp) => emp.id === empToInsert.id) === -1
		) {
			this.listOfAttendees.push(empToInsert);
			this.numberOfAttendeesSelected += 1;
			this.checkValidityOfNumberOfEmployee();
		}
		this.selectedParticipant = '';
	}

	selectAllParticipants() {
		this.listOfAttendees = [...this.listEmployee];
	}

	resetParticipantsReunion() {
		this.listOfAttendees = [...this.listOfAttendeesOriginal];
	}

	removeParticipant(p: Employee) {
		this.listOfAttendees = this.listOfAttendees.filter(
			(emp) => emp.id !== p.id
		);
		this.numberOfAttendeesSelected -= 1;
		this.checkValidityOfNumberOfEmployee();
	}

	checkValidityOfNumberOfEmployee() {
		// Vérification de validité du nombre d'intervenants
		if (
			this.formationDetailForm.value.nombreIntervenants > 0 &&
			this.numberOfAttendeesSelected <=
				this.formationDetailForm.value.nombreIntervenants
		) {
			this.isNumberOfIntervenantSelectedValid = true;
		} else {
			this.isNumberOfIntervenantSelectedValid = false;
		}

		if (
			this.numberOfAttendeesSelected >
			this.formationDetailForm.value.nombreIntervenants
		) {
			this.isDisplayableErrorSelectedEmployeesHigherThanNumberSelected = true;
		} else {
			this.isDisplayableErrorSelectedEmployeesHigherThanNumberSelected = false;
		}

		// Afficher ou non la zone de sélection d'intervenants
		if (
			this.formationDetailForm.value.nombreIntervenants > 0 &&
			this.numberOfAttendeesSelected <
				this.formationDetailForm.value.nombreIntervenants
		) {
			this.isDisplayableSelectEmployee = true;
		} else {
			this.isDisplayableSelectEmployee = false;
		}
	}

	openCopyMissionModal(copyMissionTemplate: TemplateRef<any>): void {
		this.copyMissionModalRef = this.modalService.show(copyMissionTemplate);
	}

	copyMission() {
		this.facade.missionService
			.copyMissionToDates(this.listOfDates, this.missionRequest.id)
			.subscribe({
				complete: () => {
					this.listOfDates.length = 0;
					this.copyMissionModalRef.hide();
					this.facade.toastService.createSuccessToastWithMessage(
						'Copie réalisée avec succès.'
					);
				},
				error: (err: ErrorResponse) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.response,
						err.status
					);
				}
			});
	}

	addDateToListOfDates() {
		const index = this.listOfDates.findIndex(
			(date) => date.getTime() === this.dateToAdd.getTime()
		);

		if (index === -1) {
			this.listOfDates.push(this.dateToAdd);
		}
	}

	removeDateFromList(date: Date) {
		const index = this.listOfDates.indexOf(date);
		if (index !== -1) {
			this.listOfDates.splice(index, 1);
		}
	}

	addIntervenants() {
		this.facade.formationService
			.updateNombreIntervenant(this.missionRequest.id)
			.subscribe({
				next: () => {},
				error: (err) => {
					this.logger.error(err);
				},
				complete: () => {
					window.location.reload();
				}
			});
	}
}

export function workingTimeValidator(min: number, max: number): ValidatorFn {
	return (control: AbstractControl) => {
		const value = control.value;

		if (!value) {
			return null;
		}
		if (typeof value !== 'object') {
			return null;
		}
		const hours = value.getHours();

		if (hours < min || hours > max) {
			return { outOfRange: true };
		}

		return null;
	};
}

export function durationValidator(maxDuration: number): ValidatorFn {
	return (control: AbstractControl) => {
		const start = control.get('readyTime')?.value;
		const end = control.get('dueTime')?.value;
		if (start && end) {
			if (end.getTime() < start.getTime()) {
				return { endBeforeStart: true };
			}
			if (end.getHours() - start.getHours() > maxDuration) {
				return { tooManyHours: true };
			}
			return null;
		}
		return null;
	};
}

/**
 * Validator vérifiant si l'école doit être obligatoire (ce n'est pas le cas pour une réunion)
 * @param maxDuration Nombre d'heure maximum
 * @returns null si pas d'erreur, l' {erreur:true} sinon
 */
export function missionPlaceRequiredOnMissionType(
	isSESSAD: boolean
): ValidatorFn {
	return (control: AbstractControl) => {
		if (!isSESSAD) {
			return null;
		}

		const missionType = control.get('typeIntervention').value;
		const missionPlace = control.get('missionPlace').value;
		if (control.get('isMissionPlaceBeneficiaireAddress').value) {
			return null;
		}

		return missionType !== MissionTypeName.REUNION &&
			missionType !== MissionTypeName.MISSION_ANNEXE &&
			(!missionPlace || missionPlace === '')
			? { missionPlaceRequired: true }
			: null;
	};
}

/**
 * Validator vérifiant si le bénéficiaire doit être obligatoire (ce n'est pas le cas pour une réunion)
 * @param maxDuration Nombre d'heure maximum
 * @returns null si pas d'erreur, l' {erreur:true} sinon
 */
export const beneficiaireRequiredOnMissionType: ValidatorFn = (
	control: AbstractControl
): ValidationErrors | null => {
	const missionType = control.get('typeIntervention').value;
	const beneficiaire = control.get('beneficiaire').value;

	return missionType !== MissionTypeName.REUNION &&
		missionType !== MissionTypeName.MISSION_ANNEXE &&
		(!beneficiaire || beneficiaire === '')
		? { beneficiaireRequired: true }
		: null;
};
